import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app-routing.module';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { provideToastr } from 'ngx-toastr';
import { authenticationInterceptor } from './auth-iterceptor/interceptors';

export const appConfig: ApplicationConfig = {
    providers: [provideRouter(routes), authenticationInterceptor, provideClientHydration(), provideAnimations(), importProvidersFrom(HttpClientModule), provideToastr()]
};